import styled from '@emotion/styled';

export const Container = styled.div`
  max-width: 1170px;
  margin-left: auto;
  margin-right: auto;
  padding: 12px;
`;

export const Title = styled.h2`
  text-transform: capitalize;
  text-align: left;
  font-size: 3.6rem;
  font-weight: 900;
  margin-bottom: 2rem;
`;
